import toast from 'react-hot-toast';

export const isFormValid = (formData) => {
  if (formData.naziv === '' || formData.naziv === null) {
    toast.error('Naziv je obavezno polje.');
    return true;
  }
  if (formData.redosled === '' || formData.redosled === null) {
    toast.error('Redosled je obavezno polje.');
    return true;
  }

  return false;
};
